function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import PropTypes from "prop-types";
import React from "react";
import classnames from "classnames";
import omit from "lodash.omit";
import Base from "../Base/Base";
import "./Card.css";
export default function Card({
  active,
  border,
  borderRadius = "small",
  children,
  className,
  hover,
  onClick,
  shade = "shade-1",
  shadow,
  size = "medium",
  ...rest
}) {
  const classes = classnames("ax-card", `ax-card--size-${size}`, {
    "ax-card--active": active,
    "ax-card--border": border,
    "ax-card--clickable": onClick,
    "ax-card--hover": hover,
    [`ax-card--${shade}`]: shade,
    [`ax-card--border-radius-${borderRadius}`]: borderRadius,
    "ax-card--shadow": shadow
  }, className);
  return /*#__PURE__*/React.createElement(Base, _extends({}, omit(rest, ["cardListStyle"]), {
    className: classes,
    onClick: onClick
  }), children);
}